export enum FiltersName {
  ProcessType = 'process_type',
  Cups = 'cups'
}